var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMostPopularDiamond = function SvgMostPopularDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M11.146 2.947H5.284a.5.5 0 0 0-.381.176l-3.14 3.694a.5.5 0 0 0 .017.667l6.072 6.45a.5.5 0 0 0 .723.006l6.257-6.447a.5.5 0 0 0 .013-.683l-3.328-3.697a.5.5 0 0 0-.371-.166ZM1.263 7.158h13.895"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m8.421 2.947-3.579 4.21 3.369 6.948"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m8.21 3.158 3.58 4.21-3.58 6.527"
  })));
};
export default SvgMostPopularDiamond;